/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyStatusQueryOperator>): PolicyStatusQueryOperator {
        let obj = Object.assign(new PolicyStatusQueryOperator(), model);
        PolicyStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyStatusQueryOperator>): PolicyStatusQueryOperator {
        if (!model) return null;
        return PolicyStatusQueryOperator.newInstance(<PolicyStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyStatusQueryOperator) {
        if (!obj) return;

        models.PolicyStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy statuses to include
     */
    statuses: Array<models.PolicyStatus>;

}
